import React from 'react';

import { Checkbox } from '_lib/components/Checkbox/Checkbox';
import { FormControlLabel } from '_lib/components/FormControlLabel/FormControlLabel';
import { Grid } from '_lib/components/Grid/Grid';
import { MenuItem } from '_lib/components/MenuItem/MenuItem';
import { TextField } from '_lib/components/TextField/TextField';
import { Typography } from '_lib/components/Typography/Typography';

import { FilterContext } from '../AppointmentBookingPane.types';

interface AppointmentBookingFiltersProps {
  filterContext: FilterContext | null;
  onFilterContextUpdate: (filterContext: FilterContext) => void;
}

export const AppointmentBookingFilters = (props: AppointmentBookingFiltersProps): React.ReactElement => {
  const { filterContext, onFilterContextUpdate } = props;

  return (
    <Grid container spacing={1} sx={{ paddingX: 1, paddingY: 1 }}>
      <Grid item xs={6} sm={6} md={3}>
        <TextField
          fullWidth
          label='Trade'
          disabled={filterContext ? filterContext.tradeFilter.isReadOnly : true}
          value={filterContext ? filterContext.tradeFilter.selectedKey : 0}
          select
          required
          error={!filterContext?.tradeFilter.selectedKey}
          onChange={(e) => {
            if (!filterContext) return;
            const parsed = parseInt(e.target.value);
            if (!isNaN(parsed)) {
              const tradeFilter = { ...filterContext.tradeFilter };
              tradeFilter.selectedKey = parsed;
              onFilterContextUpdate({ ...filterContext, tradeFilter });
            }
          }}>
          <MenuItem key={0} value={0}>
            --
          </MenuItem>
          {filterContext?.tradeFilter.options.map((option) => (
            <MenuItem key={option[0]} value={option[0]}>
              {option[1]}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={6} sm={6} md={3}>
        <TextField
          fullWidth
          label='Service Type'
          disabled={filterContext ? filterContext.serviceTypeFilter.isReadOnly : true}
          value={filterContext ? filterContext.serviceTypeFilter.selectedKey : 0}
          select
          required
          error={!filterContext?.serviceTypeFilter.selectedKey}
          onChange={(e) => {
            if (!filterContext) return;
            const parsed = parseInt(e.target.value);
            if (!isNaN(parsed)) {
              const serviceTypeFilter = { ...filterContext.serviceTypeFilter };
              serviceTypeFilter.selectedKey = parsed;
              onFilterContextUpdate({ ...filterContext, serviceTypeFilter });
            }
          }}>
          <MenuItem key={0} value={0}>
            --
          </MenuItem>
          {filterContext?.serviceTypeFilter.options.map((option) => (
            <MenuItem key={option[0]} value={option[0]}>
              {option[1]}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={6} sm={6} md={3}>
        <TextField
          fullWidth
          label='Label'
          disabled={filterContext ? filterContext.windowLabelFilter.isReadOnly : true}
          value={filterContext ? filterContext.windowLabelFilter.selectedKey : 0}
          select
          onChange={(e) => {
            if (!filterContext) return;
            const parsed = parseInt(e.target.value);
            if (!isNaN(parsed)) {
              const windowLabelFilter = { ...filterContext.windowLabelFilter };
              windowLabelFilter.selectedKey = parsed;
              onFilterContextUpdate({ ...filterContext, windowLabelFilter });
            }
          }}>
          <MenuItem key={0} value={0}>
            --
          </MenuItem>
          {filterContext?.windowLabelFilter.options.map((option) => (
            <MenuItem key={option[0]} value={option[0]}>
              {option[1]}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={6} sm={6} md={3} sx={{ alignSelf: 'center' }}>
        <FormControlLabel
          control={
            <Checkbox
              color='primary'
              disabled={!filterContext}
              checked={filterContext ? filterContext.warrantyFilter.selectedKey === true : false}
              onChange={(e) => {
                if (!filterContext) return;
                onFilterContextUpdate({
                  ...filterContext,
                  warrantyFilter: { ...filterContext.warrantyFilter, selectedKey: !!e.target.checked }
                });
              }}
            />
          }
          label={<Typography text='Warranty' />}
        />
      </Grid>
    </Grid>
  );
};
